<div class="pronunciation-feedback">
  @if (speechAvailable()) {
    <div
      #sentenceToolbar
      class="pronunciation-feedback__sentence"
      role="toolbar"
      [attr.aria-label]="'QUESTIONS.PRONUNCIATION.LISTEN.TOOLBAR' | translate"
      [attr.aria-describedby]="hintId"
    >
      <div class="pronunciation-feedback__controls">
        <button
          type="button"
          class="pronunciation-feedback__listen"
          [id]="listenId"
          data-speech-item
          [class.playing]="isSentencePlaying()"
          [attr.tabindex]="tabStopIndex() === 0 ? 0 : -1"
          [attr.aria-label]="
            (isSentencePlaying()
              ? 'QUESTIONS.PRONUNCIATION.LISTEN.STOP'
              : 'QUESTIONS.PRONUNCIATION.LISTEN.SENTENCE'
            ) | translate
          "
          (focus)="activeItemIndex.set(0)"
          (click)="toggleSentence()"
        >
          <odl-icon aria-hidden="true" [name]="isSentencePlaying() ? 'pause' : 'play'"></odl-icon>
        </button>
        <odl-tooltip placement="top" [attr.for]="'#' + listenId">{{
          (isSentencePlaying()
            ? 'QUESTIONS.PRONUNCIATION.LISTEN.STOP'
            : 'QUESTIONS.PRONUNCIATION.LISTEN.SENTENCE'
          ) | translate
        }}</odl-tooltip>
        <button
          type="button"
          class="pronunciation-feedback__listen pronunciation-feedback__slow"
          data-speech-item
          [id]="slowId"
          [class.playing]="isSlowSentencePlaying()"
          [attr.tabindex]="tabStopIndex() === slowItemIndex ? 0 : -1"
          [attr.aria-label]="
            (isSlowSentencePlaying()
              ? 'QUESTIONS.PRONUNCIATION.LISTEN.STOP'
              : 'QUESTIONS.PRONUNCIATION.LISTEN.SLOW'
            ) | translate
          "
          (focus)="activeItemIndex.set(slowItemIndex)"
          (click)="toggleSlowSentence()"
        >
          <odl-icon
            aria-hidden="true"
            [name]="isSlowSentencePlaying() ? 'pause' : 'turtle'"
          ></odl-icon>
        </button>
        <odl-tooltip placement="top" [attr.for]="'#' + slowId">{{
          (isSlowSentencePlaying()
            ? 'QUESTIONS.PRONUNCIATION.LISTEN.STOP'
            : 'QUESTIONS.PRONUNCIATION.LISTEN.SLOW'
          ) | translate
        }}</odl-tooltip>
      </div>
      <div class="pronunciation-feedback__words">
        @for (word of assessedWords(); track $index) {
          @if (word.itemIndex !== undefined) {
            <button
              nrTourAnchor="word"
              type="button"
              class="pronunciation-feedback__word"
              data-speech-item
              [ngClass]="word.style"
              [class.playing]="activePlayback()?.id === word.playbackId"
              [class.selected]="selectedIndex() === $index"
              [attr.aria-expanded]="selectedIndex() === $index"
              [attr.aria-controls]="selectedIndex() === $index ? wordDetailId : null"
              [attr.tabindex]="tabStopIndex() === word.itemIndex ? 0 : -1"
              [attr.aria-label]="
                word.labelKey
                  | translate
                    : {
                        word: word.speechText,
                        result: word.resultLabel ? (word.resultLabel | translate) : '',
                      }
              "
              (focus)="activeItemIndex.set(word.itemIndex)"
              (click)="openWord($index)"
            >
              {{ word.text }}
            </button>
          } @else {
            <span class="pronunciation-feedback__word" [ngClass]="word.style">{{ word.text }}</span>
          }
        }
      </div>
    </div>
    <span class="visually-hidden" [id]="hintId">{{
      'QUESTIONS.PRONUNCIATION.LISTEN.HINT' | translate
    }}</span>
    @if (selectedWordDetail(); as detail) {
      <div #wordDetail [id]="wordDetailId">
        <nr-pronunciation-word-detail
          [detail]="detail"
          [playing]="isSelectedWordPlaying()"
          (listen)="playSelectedWord()"
          (dismiss)="closeWordDetail()"
        ></nr-pronunciation-word-detail>
      </div>
    }
  } @else {
    <p class="pronunciation-feedback__sentence pronunciation-feedback__words">
      @for (word of assessedWords(); track $index) {
        <span class="pronunciation-feedback__word" [ngClass]="word.style">{{ word.text }}</span>
      }
    </p>
  }
</div>
